<template>
  <div class="highlight-container referral-home-banner-height  px-4">
    <div class="highlight-wrapper pt-4" style="width: 100%">
      <div class="third-row-container">
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box first_box_match" style="overflow-x:hidden;">
          <v-col cols="6" class="pa-0">
            <div class="h3 white--text pb-2">{{ $t(`label.earnEasily`) }}</div>
          </v-col>
          <v-col cols="6" class="pa-0">
            <div class="h3 white--text pb-2 text-uppercase">{{ $t(`label.instantcashbonus`) }}</div>
          </v-col>
        </div>
      </div>
      <div>
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box first_box_match" style="overflow-x: hidden;">
          <v-row no-gutters>
            <v-col cols="12" class=" pa-0">
              <div class="h3 white--text pb-2">{{ $t(`label.earnEasily`) }}</div>
            </v-col>
            <v-col cols="12" class="pa-0">
              <router-link :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }" style="cursor: pointer;">
                <img loading="lazy" alt="referral" :src="`/static/image/referral/${language}/Mobile_Before_Login.png`" class="referral_img" />
              </router-link>
            </v-col>
            <v-col cols="12" class=" pa-0">
              <div class="h3 white--text pb-2 text-uppercase">{{ $t(`label.instantcashbonus`) }}</div>
            </v-col>
            <v-col cols="12" class="pa-0">
              <div @click="goToDepositPage()" style="cursor: pointer;">
                <img loading="lazy" alt="deposit percentage" :src="`/static/image/referral/${language}/deposit_bonus_banner_${language.toLowerCase()}.png`" class="referral_img" />
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box first_box_match" style="overflow-x:hidden;">
          <v-col cols="6" class="pa-0">
            <v-col cols="11" class="pa-0">
              <router-link :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }" style="cursor: pointer;">
                <img loading="lazy" alt="referral" :src="`/static/image/referral/${language}/Mobile_Before_Login.png`" class="referral_img" />
              </router-link>
            </v-col>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-col cols="11" class="pa-0">
              <div @click="goToDepositPage()" style="cursor: pointer;">
                <img loading="lazy" alt="deposit percentage" :src="`/static/image/referral/${language}/deposit_bonus_banner_${language.toLowerCase()}.png`" class="referral_img" />
              </div>
            </v-col>
          </v-col>
        </div>
      </div>
      <div v-if="false">
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box first_box_match" style="overflow-x:hidden; padding-bottom: 0px !important;">
          <div class="referral_mobile">
            <img loading="lazy" src="/static/image/referral/referral_icon.png" class="float2" />
            <v-img :src="`/static/image/referral/background.jpg`" max-width="100vw" class="referral_mobile_img">
              <v-row class="referral_home_word">
                <p class="text-uppercase" style="margin-bottom:0px">
                  {{ $t(`label.extra`) }}
                  <span style="color: #FFF700;">{{ $t(`label.instantamount`) }}</span>
                  {{ $t(`label.weeklyCommission`) }}
                </p>
                <br />
                <p class="text-uppercase" style="margin-bottom:1%">
                  {{ $t(`label.referralUpto`) }}
                  <span style="color: #FFF700;">{{ $t(`label.percentage`) }}</span>
                  {{ $t(`label.lifetimeCommission`) }}
                </p>
              </v-row>
              <v-row class="referral_home_word2">
                <p>{{ $t(`label.referralsubtitle`) }}</p>
              </v-row>
              <v-row class="referral_mobile_row no-gutters">
                <v-col cols="12">
                  <v-row class="referral-code fill-height no-gutters">
                    <v-col cols="5" class="referral_code_col">
                      <vue-qr-code name="asd" v-if="overview.my_referral_code" class="referralQRCode" style="max-width: 100%;" :text="share_url"></vue-qr-code>
                    </v-col>
                    <v-col cols="7" class="referral_details_col d-flex align-center">
                      <img loading="lazy" class="float" src="/static/image/referral/coinRight.png" />
                      <v-col cols="12" style="padding: 0px;">
                        <app-form-field
                          small
                          readonly
                          :enabled-label="true"
                          :label="$t(`field.referralCode`)"
                          class="blue-text-referral"
                          v-model="overview.my_referral_code"
                          :value="overview.my_referral_code"
                        >
                          <template v-slot:form-field-append>
                            <v-fade-transition leave-absolute>
                              <img loading="lazy" width="13" height="13" src="/static/image/referral/copyBtn.png" alt="" @click="referralCodeCopy" />
                            </v-fade-transition>
                          </template>
                        </app-form-field>
                        <app-form-field
                          readonly
                          :enabled-label="true"
                          :label="$t(`label.todayCommission`)"
                          class="blue-text-referral"
                          :prefix="currencySymbolMapp(currentCurrency)"
                          v-model="overview.commission_balance"
                          :value="overview.commission_balance"
                        ></app-form-field>
                        <div class="d-flex justify-space-between" style="margin-top: 5px">
                          <v-btn class="shareNow dialog-button   text-capitalize " @click="share()">
                            <v-icon class="" x-small>mdi-share-variant</v-icon>
                            {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}
                          </v-btn>
                          <v-btn class="shareNow refeerral_report_btn" @click="routeToReferralReport">{{ $t(`button.referralReport`) }}</v-btn>
                        </div>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-img>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box first_box_match" style="overflow-x:hidden; ">
          <v-img :src="`/static/image/referral/${language}/background-with-wording.jpg`" class="referral_desktop_img">
            <v-row no-gutters class="fill-height">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="referral_qr_desktop">
                <v-row class="referral-code fill-height no-gutters">
                  <v-col cols="6" class="referral_code_col" style="padding: 24px 15px">
                    <vue-qr-code name="asd" v-if="overview.my_referral_code" class="referralQRCode" :text="share_url"></vue-qr-code>
                  </v-col>
                  <v-col cols="6" class="referral_details_col">
                    <app-form-field readonly :enabled-label="true" class="blue-text-referral" :label="$t(`field.referralCode`) + ':'" v-model="overview.my_referral_code" :is-optional="true">
                      <template v-slot:form-field-append>
                        <v-fade-transition leave-absolute>
                          <img loading="lazy" width="24" height="24" src="/static/image/referral/copyBtn.png" alt="" @click="referralCodeCopy" />
                        </v-fade-transition>
                      </template>
                    </app-form-field>
                    <app-form-field
                      readonly
                      :enabled-label="true"
                      :prefix="currencySymbolMapp(currentCurrency)"
                      class="blue-text-referral"
                      :label="$t(`label.todayCommission`) + ':'"
                      v-model="overview.commission_balance"
                      :is-optional="true"
                    ></app-form-field>
                    <v-btn class="dialog-button subtitle-1 full-width text-capitalize pa-2 mb-2" @click="share()">
                      <v-icon class="mr-2">mdi-share-variant</v-icon>
                      {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}
                    </v-btn>
                    <v-btn class="full-width refeerral_report_btn" @click="routeToReferralReport">{{ $t(`button.referralReport`) }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import { SHARED } from '@/constants/constants'
import { ROUTE_NAME } from '@/constants/route.constants'
import { REFERRAL_GET_OVERVIEW } from '@/store/referral.module'
import VueQrCode from 'vue-qrcode-component'
import currencySymbolMapp from 'currency-symbol-map'
import stringFormat from 'string-format'

export default {
  name: 'ReferralHomeBanner',
  components: {
    VueQrCode
  },
  data: () => ({
    stringFormat: stringFormat,
    currencySymbolMapp: currencySymbolMapp,
    currentCurrency: uiHelper.getCurrency(),
    regionLocale: uiHelper.getRegionLocale(),
    language: uiHelper.getLanguage().toLowerCase(),
    routeName: ROUTE_NAME,
    overview: {},
    share_url: ''
  }),
  created() {
    this.getMemberReferralOverview()
  },
  computed: {
    formattedValue() {
      const currencySymbol = this.currencySymbolMapp.currencySymbolMap[this.currentCurrency]
      const value = '10,000'
      return `${currencySymbol}${value}`
    },
    uiHelper() {
      return uiHelper
    },
    webShareApiSupported() {
      return navigator.share
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    referralOverview() {
      return this.$store.state.referral.overview
    }
  },
  watch: {
    isLoggedIn() {
      this.getMemberReferralOverview()
    },
    referralOverview() {
      this.overview = this.$store.state.referral.overview
      if (window.location.host.toLowerCase() === '8795158bn1.com') {
        this.share_url = 'https://nagad88.best' + '?refer_code=' + this.overview.my_referral_code
      } else {
        // If not, construct the share URL normally
        this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
      }
    }
  },
  methods: {
    goToDepositPage() {
      if (this.isLoggedIn) {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params.lang,
            tab: 'deposit'
          }
        })
      } else {
        this.$parent.openLoginDialog()
      }
    },
    referralCodeCopy() {
      // console.log('referral code appendIcon CLICKED,refer code : '+ this.overview.my_referral_code)
      navigator.clipboard.writeText(this.overview.my_referral_code)
    },
    share() {
      const sharing = {
        title: locale.getMessage(`message.referralShareTitle`),
        text: locale.getMessage('message.referralShareMsg'),
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    },
    getMemberReferralOverview() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
      }
    },
    routeToReferralPage() {
      if (this.isLoggedIn) {
        this.$router.push({
          name: ROUTE_NAME.REFERRAL_SUMMARY
        })
      } else {
        this.$parent.openLoginDialog()
      }
    },
    routeToReferralReport() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_REPORT
      })
    }
  }
}
</script>

<style lang="scss">
.referral-home-row2-text {
  font-family: 'poppins Bold', sans-serif;
  margin-bottom: 0px !important;
  padding-left: 65px;
  height: 75px;
  font-size: 57px;
  font-weight: 1000;
  //text-shadow: 2px 2px 4px rgba(37, 15, 255, 0.5);
  //text-shadow: 3px 0 #750fff;
  //text-shadow: 2px 2px 4px #750fff;
  background: linear-gradient(to bottom, #260fff, #750fff, #260fff, #750fff) center;
  -webkit-background-clip: text; /* Apply the gradient to text */
  -webkit-text-fill-color: transparent; /* Make the text transparent to show the gradient */
}
.referral-home-row2-text-bd {
  font-family: 'Noto Sans Bengali Bold', sans-serif;
  margin-bottom: 0px !important;
  padding-left: 65px;
  height: 75px;
  font-size: 57px;
  font-weight: 1000;
  background: linear-gradient(to bottom, #260fff, #750fff, #260fff, #750fff) center;
  -webkit-background-clip: text; /* Apply the gradient to text */
  -webkit-text-fill-color: transparent; /* Make the text transparent to show the gradient */
}
.yellow-referral-text {
  color: #ffde01;
  font-size: 30px;
  font-weight: bolder;
}
.yellow-referral-text-bd {
  color: #ffde01;
  font-size: 30px;
  font-weight: 600;
}
.referral-home-row1-text {
  font-size: 25px;
  font-weight: normal;
  gap: 8px;
  display: flex;
  align-items: end;
  margin-bottom: 0px !important;
}
.referral-home-row1-text-bd {
  letter-spacing: 1px;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 25px;
  font-weight: 400;
  gap: 8px;
  display: flex;
  align-items: end;
  margin-bottom: 0px !important;
}
.referralQRCode canvas {
  max-width: 95%;
}
.tierPng .v-image__image {
  background-size: 100%;
}
.referral-home-row1 {
  padding: 15px 0px 20px 75px;
}
.referral-home-row2 {
  margin: 0px !important;
  padding: 0px;
}
.blue-text-referral .v-text-field .v-input__control {
  padding-top: 0px;
}
.shareNow {
  width: 47% !important;
  font-size: 9px !important;
  min-width: 47% !important;
}
$referralMobileHeight: 375px;
$referrlDesktopHeight: 350px;
$referralColPadding: 20px 20px;
.blue-text-referral {
  color: #001958 !important;
  font-weight: bolder;
  .input-field-login.v-input--is-readonly input {
    color: #001958 !important;
    font-weight: bolder;
    font-size: 12px;
  }
  .v-text-field .v-text-field__prefix {
    color: white !important;
    font-weight: bolder;
    font-size: 12px;
  }
  .v-text-field__prefix {
    color: white !important;
    font-weight: bolder;
    font-size: 12px;
  }
}
.referral-text-area .v-input__slot {
  background: #d8d8d8 !important;
}

.blue-text-referral input {
  color: #001958 !important;
  font-weight: bolder;
  font-size: 12px;
}
.float {
  position: absolute;
  z-index: 1;
  right: -10px;
  top: 52px;
  height: 47px;
  width: 49px;
}
.float2 {
  position: absolute;
  z-index: 1;
  left: -10px;
  top: 44px;
  height: 80px;
  width: 81px;
}
.float3 {
  position: absolute;
  z-index: 1;
  left: -25px;
  bottom: -25px;
  height: 110px;
  width: 80px;
  padding-top: 35px;
}
.float4 {
  position: absolute;
  z-index: 1;
  left: -2%;
  top: 81px;
  height: 110px;
  width: 80px;
  padding-top: 35px;
}
.float5 {
  position: absolute;
  z-index: 1;
  left: 40%;
  top: 100px;
  height: 110px;
  width: 80px;
  padding-top: 35px;
}
.float7 {
  position: absolute;
  z-index: 1;
  left: -1%;
  top: -20px;
  height: 70px;
  width: 41px;
  padding-top: 35px;
}
.float6 {
  position: absolute;
  z-index: 1;
  left: 42%;
  bottom: -25px;
  height: 126px;
  width: 100px;
  padding-top: 35px;
}
.referral-home-banner-height .highlight-wrapper .matches-box {
  padding-bottom: 0px !important;
}
.referral_home_word {
  gap: 7px;
  padding-top: 5%;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bolder;
  background-color: #8d1cff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.referral_home_word-desktop {
  //padding-top: 4%;
  margin: 0px !important;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bolder;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.referral_home_word2 {
  padding-top: 3%;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.referral_home_word3 {
  margin-top: 0px !important;
  padding-left: 78px;
  color: #fff;
  font-size: 14px;
}
.whiteBg {
  background-color: #ffffff;
}

.referral_mobile {
  max-height: $referralMobileHeight;
  max-width: 100%;

  .referral_mobile_row {
    flex-direction: column;
    padding: 15px;
    margin-top: -80px;

    .referral_msg_desc2 {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f27703 !important;
      border-radius: 5px;
      min-height: 40px;
      color: #ffffff;
      padding: 5px;
      font-size: 14px;
    }
  }

  .referral-code {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2256197478991597) 0%, rgba(255, 255, 255, 0.65) 35%, rgba(255, 255, 255, 0.853284) 100%);
    padding: 8px;
    height: 100%;
    width: 100%;
    margin-top: 60px;
    border-radius: 5px;

    .referral_code_col {
      //background-color: rgb(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      .referralQRCode {
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        background-color: #ffffff;
        padding: 10px;
      }
      .referralQRCode {
        img {
          width: 95% !important;
          height: auto !important;
        }
      }
    }
    .referral_details_col {
      //padding-right: 15px;
      //padding-top: 5px;
      padding-left: 8px;
      //padding-right: 5px;

      .v-btn:not(.v-btn--round).v-size--default {
        height: 22px !important;
        width: 100%;
      }
      .input-field-label {
        font-size: 11px !important;
      }
      .v-input__control {
        .v-input__slot {
          min-height: 20px;
          height: 7px;
        }
        .v-text-field__details {
          margin-bottom: 0px !important;

          .v-messages__message {
            font-size: 11px;
          }
        }
      }

      .v-text-field__details {
        height: 3px;
        min-height: 0px !important;
      }

      .dialog-button {
        width: 100%;
        padding: 0 7px;
        color: #ffffff;
        background-image: linear-gradient(to bottom, #ffab2d, #ff7700);
        font-size: 0.6rem;
      }
      //background-color: rgb(255, 255, 255, 0.2);
      .refeerral_report_btn {
        width: 95%;
        padding: 0 5px 0 5px;
        background-image: linear-gradient(to bottom, #0047ff, #5a00b4);
        color: #ffffff;
        font-size: 0.6rem;
        text-transform: capitalize;
      }
    }
  }
}

.referral_mobile_img {
  max-height: $referralMobileHeight;
  max-width: 100vw;
}
.referral_desktop_img {
  //max-height: $referrlDesktopHeight;
  max-height: 100% !important;
}
//background: linear-gradient(90deg, rgba(255,255,255,0.2256197478991597) 0%, rgba(255,255,255,0.65) 35%, rgba(255,255,255,0.853284) 100%);
.referral_qr_desktop {
  //margin-left: 580px;
  background-color: transparent;
  padding: 20px 15px !important;
  align-content: center;
  .referral-code {
    position: relative;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2256197478991597) 0%, rgba(255, 255, 255, 0.65) 35%, rgba(255, 255, 255, 0.853284) 100%);
    align-items: center;
    width: 100%;
    border-radius: 10px;

    .megePhone_desktop {
      position: absolute;
      width: 50px;
      height: 50px;
      top: -20px;
      right: -20px;
      -ms-transform: rotate(-20deg); /* IE 9 */
      transform: rotate(-20deg);
    }

    .referral_code_col {
      //background-color: rgb(255, 255, 255, 0.2);
      .referralQRCode {
        display: flex;
        justify-content: center;
        background: #fff;
        padding: 10px;
      }
      .referralQRCode > img {
        border: 0px;
        padding: 0px;
        margin: auto;
      }
    }
    .referral_details_col {
      padding-right: 15px;
      .dialog-button {
        color: #ffffff;
        background-image: linear-gradient(to bottom, #ffab2d, #ff7700);
        width: 100%;
      }
      //background-color: rgb(255, 255, 255, 0.2);
      .refeerral_report_btn {
        text-transform: capitalize;
        background-image: linear-gradient(to bottom, #0047ff, #5a00b4);
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
}

.referral_desc_desktop {
  .referral_msg {
    padding: $referralColPadding;
    color: #ffffff;
    align-content: space-evenly;
    position: relative;

    .referralIcon_desktop {
      position: absolute;
      width: 55px;
      height: 55px;
      bottom: 55px;
      right: -20px;
      -ms-transform: rotate(-20deg); /* IE 9 */
      transform: rotate(-20deg);
    }

    .referral_msg_desc1 {
      position: relative;
      .moneyHand_desktop {
        position: absolute;
        width: 55px;
        height: 55px;
        top: -8px;
        right: -45px;
        -ms-transform: rotate(-20deg); /* IE 9 */
        transform: rotate(-20deg);
      }
    }
    .referral_msg_desc2 {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f27703 !important;
      border-radius: 5px;
      min-height: 40px;
      color: #ffffff;
    }
    .referral_msg_tnc {
      font-size: 0.85rem;
      filter: drop-shadow(0 0 0.85rem #3a3a3a);
    }
  }
}

.referral-home-banner-height {
  /*height: 500px;*/
}

//@media (max-width: 400px) {
//  .qrCode > img {
//    max-height: 95px !important;
//    max-width: 95px !important;
//  }
//}

@media screen and (min-width: 510px) {
  .referralQRCode > img {
    max-height: auto !important;
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
  }

  .referral_code_col {
    justify-content: center;
  }
}
//@media screen and (min-width: 980px){
//  //.referralQRCode > img {
//  //  max-height: 190px !important;
//  //  max-width: 190px !important;
//  //  width: 190px !important;
//  //  height: 190px !important;
//  //}
//  .blue-text-referral .v-text-field .v-input__control{
//    padding-top: 0px;
//  }
//}
@media screen and (min-width: 980px) {
  .blue-text-referral .v-text-field .v-input__control {
    padding-top: 0px;
  }
  .blue-text-referral input {
    color: #000000 !important;
    font-weight: bolder;
    font-size: 15px;
  }

  .blue-text-referral {
    color: #000000 !important;
    font-weight: bolder;

    label {
      font-size: 18px !important;
    }
    .input-field-login.v-input--is-readonly input {
      color: #000000 !important;
      font-weight: bolder;
      font-size: 18px;
      opacity: 1;
    }
    .v-text-field .v-text-field__prefix {
      color: #000000 !important;
      font-weight: bolder;
      font-size: 15px;
    }
    .v-text-field__prefix {
      color: #000000 !important;
      font-weight: bolder;
      font-size: 15px;
    }
    .v-text-field input {
      padding: 4px 0 4px;
    }
    .v-text-field__details {
      height: 5px;
      min-height: 5px;
    }
    .input-field-login .v-input__control .v-input__slot {
      min-height: 30px;
      height: 30px;
      padding: 20px 12px !important;
      margin: 4px auto 8px;
    }
  }
}
@media (max-width: 540px) {
  .input-field-login-label {
    font-size: 14px !important;
  }
  .blue-text-referral .input-field-login.v-input--is-readonly input {
    font-size: 9px;
    opacity: 1;
  }
  .referral_home_word {
    font-size: 19px;
  }
  .referral_home_word2 {
    font-size: 14px;
  }
}
@media (max-width: 450px) {
  .referral_home_word {
    font-size: 16px;
  }
  .referral_home_word2 {
    font-size: 13px;
  }
  .float {
    height: 25px;
    width: 28px;
    right: -8px;
  }
  .float2 {
    height: 38px;
    width: 39px;
  }
  .float3 {
    height: 72px;
    width: 40px;
    left: -15px;
    bottom: -10px;
  }
}
@media (max-width: 370px) {
  .shareNow {
    width: 47% !important;
    font-size: 7px !important;
    min-width: 47% !important;
  }
  .referral_home_word {
    font-size: 12px;
  }
  .referral_home_word2 {
    font-size: 11px;
  }
}
//@media (max-width: 420px) {
//  .referralQRCode > img {
//
//    width: 65px!important;
//    height: 65px!important;
//  }
//}
//
//@media (max-width: 432px) {
//  .qrCode > img {
//    max-height: 88px !important;
//    max-width: 88px !important;
//    width: 85px!important;
//    height: 85px!important;
//  }
//}

@media (max-width: 599px) {
  .referral-home-banner-height {
    /*height: 254px;*/
  }
}

.referral_img {
  height: auto;
  width: 100%;
  /*aspect-ratio: 945/400;*/
}

@media (min-width: 599px) {
  .referral_img {
    height: 350px;
    aspect-ratio: 1240/400;
  }
}

@media (max-width: 1200px) {
  .referral-home-row1-text,
  .referral-home-row1-text-bd {
    font-size: 20px;
  }
  .yellow-referral-text {
    font-size: 25px;
  }
  .referral-home-row2-text {
    font-size: 50px;
  }
}
</style>
